export default __webpack_public_path__ + "static/docker-5b8f5506e2baa8eb0c1c451846e7f0db.svg";